import { AxiosError } from 'axios';

export const parseError = (error: unknown) => {
  // Extend type catching when required
  if (error instanceof AxiosError && error.response?.data) {
    return `${error.message}: ${JSON.stringify(error.response.data)}`;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return String(error);
};
